export const ArrowRight = () => (
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.59292 14.887C5.97818 15.2341 6.59932 15.2341 6.98459 14.887L13.5184 9.00078C13.825 8.72453 13.825 8.27828 13.5184 8.00203L6.98459 2.11578C6.59932 1.7687 5.97818 1.7687 5.59292 2.11578C5.20765 2.46286 5.20765 3.02245 5.59292 3.36953L11.2854 8.50495L5.58505 13.6404C5.20765 13.9804 5.20765 14.547 5.59292 14.887Z"
      fill="#2F8370"
    />
  </svg>
);
